import { DocumentNode } from '@apollo/client';
import { fetchExperimentVariants } from 'api/queries';
import { ExperimentVariant } from 'modules/graphql/types';
import { useMemo } from 'react';
import { useGraphql } from 'utils/hooks/useGraphql';

export function useExperimentVariantsById(
  experimentId: number | null,
  query: DocumentNode = fetchExperimentVariants,
): ExperimentVariant[] {
  const queryVariables = useMemo(() => ({ variables: { id: experimentId } }), [experimentId]);
  const { data } = useGraphql(query, queryVariables);
  return data?.experiment?.variations || [];
}
